import { memo } from "react";
import {
  DeltaGammaIncDec,
  IAdjustment2SearchParam,
} from "../../../Interfaces/deltaHedgeAdjustment";
import DeltaGammaTable from "../../../Tables/OptionDomain/Adjustment2/DeltaGammaTable";

interface IProps {
  searchParams: IAdjustment2SearchParam;
}

const Adjustment2TablesWrapper = memo(({ searchParams }: IProps) => {
  return (
    <div className="flex flex-col justify-start items-start gap-3 w-full">
      <>
        <div className="flex flex-col justify-start items-start gap-2 w-full">
          <div className="flex flex-col justify-start items-start gap-2 w-full">
            <div className="text-xs">تعدیل افزایشی</div>
            <div className="flex flex-row justify-start items-start gap-5 w-full">
              <div className="flex flex-col justify-start items-start gap-2 w-1/2">
                <div className="text-xs">افزایش دلتا - افزایش گاما</div>
                <DeltaGammaTable
                  searchParams={{
                    ...searchParams,
                    delta: DeltaGammaIncDec.Incremental,
                    gamma: DeltaGammaIncDec.Incremental,
                  }}
                />
              </div>
              <div className="flex flex-col justify-start items-start gap-2 w-1/2">
                <div className="text-xs">افزایش دلتا - کاهش گاما</div>
                <DeltaGammaTable
                  searchParams={{
                    ...searchParams,
                    delta: DeltaGammaIncDec.Incremental,
                    gamma: DeltaGammaIncDec.Decremental,
                  }}
                />
              </div>
            </div>
          </div>
          <div className="flex flex-row justify-start items-start gap-5 w-full">
            <div className="flex flex-col justify-start items-start gap-2 w-1/2">
              <div className="text-xs">کاهش دلتا - افزایش گاما</div>
              <DeltaGammaTable
                searchParams={{
                  ...searchParams,
                  delta: DeltaGammaIncDec.Decremental,
                  gamma: DeltaGammaIncDec.Incremental,
                }}
              />
            </div>
            <div className="flex flex-col justify-start items-start gap-2 w-1/2">
              <div className="text-xs">کاهش دلتا - کاهش گاما</div>
              <DeltaGammaTable
                searchParams={{
                  ...searchParams,
                  delta: DeltaGammaIncDec.Decremental,
                  gamma: DeltaGammaIncDec.Decremental,
                }}
              />
            </div>
          </div>
        </div>
      </>
    </div>
  );
});

export default Adjustment2TablesWrapper;
